import React from "react";
import styles from "./Button.module.scss";
import plus_icon from "../../../assets/images/actions/plus_icon.svg";

interface ButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  className?: string;
  full?: boolean;
  icon?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  children,
  type = "button",
  disabled = false,
  className = "",
  full = false,
  icon = false,
}) => {
  const buttonStyle = full ? { width: "100%" } : {};
  return (
    <button
      style={buttonStyle}
      type={type}
      className={`${styles.main_button} ${className} ${
        disabled ? styles.disabled : ""
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {icon ? (
        <div>
          <img src={plus_icon} alt="" />
        </div>
      ) : null}
      <p>{children}</p>
    </button>
  );
};

export default Button;
